// extracted by mini-css-extract-plugin
module.exports = {"grid":"InputItem_grid__2_487","label":"InputItem_label__1eXzk","input":"InputItem_input__t6qNe"};